import { defineMessages } from 'react-intl';

export default defineMessages({
    damageTypeSpecifyTheDamageLabel: {
        id: 'anonymous.wizard.fnol.pages.basic-information.Damage Type',
        defaultMessage: 'Specify the damage *'
    }
});
